import { DateTime } from 'luxon';
import { SortOrder, type PaginationConfig, type QueryParams } from '../records';
import { AnnouncementViews } from './types';

// @ts-expect-error FIXME: interface extension error (TS2430)
export interface AnnouncementsPagination extends PaginationConfig {
  queryParams?: AnnouncementsQueryParams;
}

// @ts-expect-error FIXME: interface extension error (TS2430)
export interface AnnouncementsQueryParams extends QueryParams {
  start_date_start?: string;
  start_date_end?: string;
  end_date_start?: string;
  end_date_end?: string;
  last_modified_start?: string;
  status?: AnnouncementViews;
  limit?: number;
  page?: number;
  sortBy?: string;
  sortOrder?: SortOrder;
}

export const announcementsListPaginationConfig: AnnouncementsPagination = {
  queryParams: {
    status: AnnouncementViews.LIVE,
    end_date_start: DateTime.local().toJSDate().toISOString(),
    end_date_end: DateTime.local().plus({ days: 365 }).endOf('day').toJSDate().toISOString(),
    limit: 25,
    page: 1,
    sortBy: 'end_date_start',
    sortOrder: SortOrder.DESC,
  },
  metaParams: {
    resultCount: 0,
    totalPages: 1,
    totalResults: 0,
  },
};
